<template>
  <div class="animated fadeIn">
    <b-card>
      <b-card-header>
        <i class="icon-menu mr-1"></i>裝置管理
        <!--<div class="card-header-actions hidden">
          <b-link @click="openEditor()" v-if="!cannotEdit"><i class="fa fa-plus"></i> 新增</b-link>
        </div>-->
        <div class="card-header-actions">
          <b-link @click="openMonthReport()"><i class="fa fa-download"></i>分潤報表下載</b-link>
        </div>
      </b-card-header>
      <b-card-body>
        <div class="row">
          <div class="col-12 d-flex justify-content-center">
            <div style="width: 95%;" class="mx-auto">
              <div>查看所屬公司場域:</div>
              <div v-if="companyStructuresData != null">
                <div v-for="(company, idx) in companyStructuresData" :key="idx">
                  [{{ company.name }}]&nbsp;
                  <div v-if="company.isExpanded && company.subCompanies && company.subCompanies.length > 0">
                    <b-button style="margin: 3px 3px 3px 0; color: white;" size="sm" variant="success" @click="toggleAllCheckboxes(company, true)">選擇全部</b-button>
                    <b-button style="margin: 3px 3px 3px 3px; color: white;" size="sm" variant="danger" @click="toggleAllCheckboxes(company, false)">清除全部</b-button>&nbsp;
                  </div>
                  <div v-if="company.isExpanded && company.subCompanies && company.subCompanies.length > 0" class="scrollable-div">
                    <tree-view v-for="(subCompany, index) in company.subCompanies" :key="index" :data="subCompany"  @toggle-event="handleToggle"></tree-view>
                  </div>
                </div>
              </div>
              <b-button v-if="selectedMeters.length > 0 && true" variant="success" class="center-btn-sm" @click="openMeterHistory()">顯示電表歷史紀錄</b-button>
              <div class="mt-3">裝置列表:</div>
            </div>
          </div>
          
          <div class="col-12">
            
            <v-server-table :columns="columns" :data="data" :options="options" :theme="theme" ref="dataTable" id="dataTable">
              <a slot="end_user_id" slot-scope="props">{{props.row.EndUser ? props.row.EndUser.name : '未連結'}}</a>
              <a slot="user_id" slot-scope="props">{{props.row.Admin.firstname + ' ' + props.row.Admin.lastname}}</a>
              <a slot="device_activated" slot-scope="props" class="d-inline-block text-center w-100"><span :id="'PHolder'+props.row.sn"><i class="fa fa-question-circle"></i></span></a>
              <a slot="company_id" slot-scope="props">{{props.row.Company?props.row.Company.name:'N/A'}}</a>
              <a slot="created" slot-scope="props"><span :id="'PCHolder'+props.row.id"><i class="fa fa-question-circle"></i></span></a>

              <div slot="child_row" slot-scope="props">
                <b-button variant="success" class="btn-pill" size="sm" @click="genRow(props.row.sn)"><i class="fa fa-qrcode"></i> QRCode</b-button> &nbsp;
                <b-button variant="warning" class="btn-pill" size="sm" @click="openLog(props.row)"><i class="fa fa-list"></i> 使用紀錄</b-button> &nbsp;
                <b-button class="btn-pill" size="sm" @click="openTransLog(props.row.id)"><i class="fa fa-usd"></i> 交易紀錄</b-button> &nbsp;
                <b-button variant="dark" class="btn-pill" size="sm" @click="openProfitLog(props.row)"><i class="fa fa-usd"></i> 分潤紀錄</b-button> &nbsp;
              </div>
            </v-server-table>
          </div>
        </div>
      </b-card-body>
    </b-card>

      
    <b-modal title="裝置QR Code" v-model="showQrCode" ok-title="確定" cancel-title="取消">
      <div class="w-100 text-center">
          <img id="qrcode-canvas">
          <p class="text-muted">存取裝置的QR Code</p>
          <p class="text-primary"><a :href="device_uri" target="_blank">URI</a></p>
      </div>
    </b-modal>

    <b-modal title="使用紀錄" v-model="showLogList" ok-title="確定" :ok-only="true" size="xl" >
      <v-server-table :columns="logcolumns" :data="logdata" :options="logoptions" :theme="theme" ref="logDataTable" id="logDataTable">
        <a slot="start_time" slot-scope="props">{{props.row.start_time|htime}}</a>
        <a slot="stop_time" slot-scope="props">{{props.row.stop_time|htime}}</a>
        <a slot="end_time" slot-scope="props">{{props.row.end_time|htime}}</a>
        <a slot="billing_method" slot-scope="props">{{props.row.billing_method === 'TIME' ? '時間' : '度數'}}</a>
        <a slot="used_value" slot-scope="props">{{get_used_value(props.row)}}</a>
        <a slot="price" slot-scope="props">{{$math.round(props.row.price, 2)}}{{props.row.billing_method === 'TIME' ? '點/分鐘' : '點/度'}}</a>
        <a slot="price_peak" slot-scope="props">{{$math.round(props.row.price_peak, 2)}}{{props.row.billing_method === 'TIME' ? '點/分鐘' : '點/度'}}</a>
        <a slot="used_time_idle" slot-scope="props">{{props.row.stop_time > 0 ? get_real_used_time_idle(props.row) : 'N/A'}}</a>
        <a slot="price_idle" slot-scope="props">{{props.row.stop_time > 0 ? $math.round(props.row.price_idle, 2) + '點(' + props.row.idle_info + ')': 'N/A'}}</a>
        <a slot="created" slot-scope="props">{{props.row.created.substring(0, 16)}}</a>
        <a slot="transaction_id" slot-scope="props">{{props.row.transaction_id ? props.row.transaction_id : 'N/A' }}</a>
      </v-server-table>
    </b-modal>

    <b-modal title="分潤紀錄" v-model="showProfitLogList" ok-title="確定" :ok-only="true" size="xl" >
      <v-server-table
        :columns="profitLogcolumns"
        :data="profitLogdata"
        :options="profitLogoptions"
        :theme="theme"
        ref="profitLogDataTable"
        id="profitLogDataTable"
        class="d-none d-md-block d-lg-block d-xl-block">
        <!--<a slot="name" slot-scope="props">{{props.row.name ? props.row.name : '未知'}}</a>
        <a slot="location" slot-scope="props">{{props.row.geo_location ? props.row.geo_location : props.row.lastip}}</a>
        <a slot="inout" slot-scope="props">
          <span class="text-primary" v-if="props.row.inout==='IN'">儲值</span>
          <span class="text-warning" v-if="props.row.inout==='OUT'">扣款</span>
        </a>
        <a slot="created" slot-scope="props">{{props.row.created.substring(0, 16)}}</a>-->
        <a slot="used_watts" slot-scope="props">{{$math.round(props.row.used_watts, 2)}}度</a>
        <a slot="used_watts_peak" slot-scope="props">{{$math.round(props.row.used_watts_peak, 2)}}度</a>
        <a slot="real_used_time_idle" slot-scope="props">{{props.row.real_used_time_idle > 0 ? props.row.real_used_time_idle + '分鐘' : 'N/A'}}</a>
        <a slot="act2_profit" slot-scope="props">{{($math.add(props.row.profit_share,props.row.cost))|dn}}</a>
      </v-server-table>
    </b-modal>

    <b-modal title="分潤報表" v-model="showMonthReportList" ok-title="確定" :ok-only="true" size="xl" >
      <b-input-group class="mb-4">
        <b-input-group-prepend>
          <b-input-group-text>報表月份</b-input-group-text>
        </b-input-group-prepend>
        <v-select v-model="selectMonth" :options="month_options" @input="handleSelection" placeholder="請選擇查詢月份"></v-select>
        <b-input-group-append>
          <b-button variant="success" :disabled="profit_report_file === null" @click="download_profit_report_file"><i class="fa fa-download"></i> 報表下載</b-button>
        </b-input-group-append>
      </b-input-group>
      
      <!---->
      <div v-if="isLoading" class="text-center my-3">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
        <p>資料載入中，請稍候...</p>
      </div>
      <div v-else>
        <p><span style="font-weight: bold; color: #2373E6;">總分潤:</span></p>
        <v-server-table
          :columns="monthProfitLogcolumns"
          :data="monthProfitLogdata"
          :options="monthProfitLogoptions"
          :theme="theme"
          ref="monthProfitLogDataTable"
          id="monthProfitLogDataTable">
          <a slot="used_watts" slot-scope="props">{{$math.round(props.row.used_watts, 2)}}</a>
          <a slot="used_watts_peak" slot-scope="props">{{$math.round(props.row.used_watts_peak, 2)}}</a>
          <a slot="real_used_time_idle" slot-scope="props">{{props.row.real_used_time_idle > 0 ? props.row.real_used_time_idle + '分鐘' : 'N/A'}}</a>
          <a slot="act2_profit" slot-scope="props">{{($math.add(props.row.profit_share,props.row.cost))|dn}}</a>
        </v-server-table>
        <p><span style="font-weight: bold; color: #2373E6;">充電紀錄:</span></p>
        <v-server-table 
          :columns="monthChargingLogcolumns" 
          :data="monthChargingLogdata" 
          :options="monthChargingLogoptions" 
          :theme="theme" 
          ref="monthChargingLogDataTable" 
          id="monthChargingLogDataTable">
          <a slot="id" slot-scope="props">{{props.row.Device ? props.row.Device.name : '未連結'}}</a>
          <a slot="status" slot-scope="props">{{props.row.Device ? props.row.Device.geo_location : '未連結'}}</a>
          <a slot="start_time" slot-scope="props">{{props.row.start_time|htime}}</a>
          <a slot="stop_time" slot-scope="props">{{props.row.stop_time|htime}}</a>
          <a slot="end_time" slot-scope="props">{{props.row.end_time|htime}}</a>
          <a slot="billing_method" slot-scope="props">{{props.row.billing_method === 'TIME' ? '時間' : '度數'}}</a>
          <a slot="used_value" slot-scope="props">{{get_used_value(props.row)}}</a>
          <a slot="price" slot-scope="props">{{$math.round(props.row.price, 2)}}{{props.row.billing_method === 'TIME' ? '點/分鐘' : '點/度'}}</a>
          <a slot="price_peak" slot-scope="props">{{$math.round(props.row.price_peak, 2)}}{{props.row.billing_method === 'TIME' ? '點/分鐘' : '點/度'}}</a>
          <a slot="used_time_idle" slot-scope="props">{{props.row.stop_time > 0 ? get_real_used_time_idle(props.row) : 'N/A'}}</a>
          <a slot="price_idle" slot-scope="props">{{props.row.stop_time > 0 ? $math.round(props.row.price_idle, 2) + '點(' + props.row.idle_info + ')': 'N/A'}}</a>
          <a slot="created" slot-scope="props">{{props.row.created.substring(0, 16)}}</a>
          <a slot="transaction_id" slot-scope="props">{{props.row.transaction_id ? props.row.transaction_id : 'N/A' }}</a>
        </v-server-table>
      </div>
      

    </b-modal>

    <!--<b-modal title="總分潤紀錄" v-model="showTotalProfitLogList" ok-title="確定" :ok-only="true" size="lg" >
      <v-server-table
        :columns="totalProfitLogcolumns"
        :data="totalProfitLogdata"
        :options="month_profitLogoptions"
        :theme="theme"
        ref="totalProfitLogDataTable"
        id="totalProfitLogDataTable"
        class="d-none d-md-block d-lg-block d-xl-block">
        <a slot="name" slot-scope="props">{{props.row.name ? props.row.name : '未知'}}</a>
        <a slot="location" slot-scope="props">{{props.row.geo_location ? props.row.geo_location : props.row.lastip}}</a>
        <a slot="inout" slot-scope="props">
          <span class="text-primary" v-if="props.row.inout==='IN'">儲值</span>
          <span class="text-warning" v-if="props.row.inout==='OUT'">扣款</span>
        </a>
        <a slot="used_watts" slot-scope="props">{{$math.round(props.row.used_watts, 2)}}</a>
        <a slot="used_watts_peak" slot-scope="props">{{$math.round(props.row.used_watts_peak, 2)}}</a>
        <a slot="created" slot-scope="props">{{props.row.created.substring(0, 16)}}</a>
        <a slot="act2_profit" slot-scope="props">{{($math.add(props.row.profit_share,props.row.cost))|dn}}</a>
      </v-server-table>
    </b-modal>-->

    <b-modal title="交易紀錄" v-model="showTransLogList" ok-title="確定" :ok-only="true" size="lg" >
      <v-server-table
        :columns="transLogcolumns"
        :data="transLogdata"
        :options="transLogoptions"
        :theme="theme"
        ref="transLogDataTable"
        id="transLogDataTable"
        class="d-none d-md-block d-lg-block d-xl-block">
        <a slot="name" slot-scope="props">{{props.row.name ? props.row.name : '未知'}}</a>
        <a slot="location" slot-scope="props">{{props.row.geo_location ? props.row.geo_location : props.row.lastip}}</a>
        <a slot="inout" slot-scope="props">
          <span class="text-primary" v-if="props.row.inout==='IN'">儲值</span>
          <span class="text-warning" v-if="props.row.inout==='OUT'">扣款</span>
        </a>
        <a slot="created" slot-scope="props">{{props.row.created.substring(0, 16)}}</a>
      </v-server-table>
    </b-modal>

    <b-modal
      title="報表錯誤"
      size="sm"
      v-model="showCreateProfitReportFailModal"
      ok-title="確定"
      :ok-only="true"
      :hide-footer="false"
      :hide-header="false"
      :no-close-on-backdrop="true"
      centered
      body-class="p-4 text-center"
      header-class="bg-primary text-white text-center"
      footer-class="text-center modal-footer-center"
    >
      <div style="text-align: center; font-size: 1.2rem;color: #156e06;">
        報表產生失敗!!<br>請洽創玖科技客服人員。
      </div>
    </b-modal>

    <b-modal
      title="報表下載失敗"
      size="sm"
      v-model="showDownloadProfitReportFailModal"
      ok-title="確定"
      :ok-only="true"
      :hide-footer="false"
      :hide-header="false"
      :no-close-on-backdrop="true"
      centered
      body-class="p-4 text-center"
      header-class="bg-primary text-white text-center"
      footer-class="text-center modal-footer-center"
    >
      <div style="text-align: center; font-size: 1.2rem;color: #156e06;">
        報表下載失敗!!<br>請洽創玖科技客服人員。
      </div>
    </b-modal>

    <b-modal title="電表歷史紀錄" v-model="showMeterHistory" ok-title="確定" :ok-only="true" size="xl" >
      <div class="d-flex flex-column w-100" style="height: 90vh; min-height: 400px;">
        <div class="d-flex align-items-center justify-content-center flex-wrap">
          <span class="label-text">基準日期：</span>
          <InnoDateTimePicker 
            v-model="selected_date" 
            :max-date="max_selected_date"
            @change="onDatePicked"
          />
          <span class="mx-2 label-text">查詢：</span>
          <inno-select 
            v-model="selected_range" 
            :options="selected_range_options"
            @input="handleSelectedRange"
          />
        </div>

        <div class="d-flex align-items-center justify-content-center flex-wrap">
          <span class="range-info-box">資料區間： {{ dateRangeHint }}</span>
        </div>

        <div class="chart-panel flex-grow-1 overflow-auto">
          <template  
            v-for="(selectedMeter, meterIndex) in selectedMeters" 
            :key="meterIndex"
          >
            <div 
              v-for="(meterid, idIndex) in selectedMeter.meterids" 
              :key="meterid" 
              class="m-2"
              :class="(getGlobalIndex(meterIndex, idIndex) % 2 === 0) ? 'bg-even' : 'bg-odd'"
            >
              <history-mixed-chart
                :ref="`chart-${selectedMeter.project_name}-${meterid}`"
                :title="`${selectedMeter.name}-電表${meterid} (最高負載：${max_current_kW}kW)`"
                :data="current_kW_chart_data[`${selectedMeter.project_name}-${meterid}`]" 
                :options="current_kW_option[`${selectedMeter.project_name}-${meterid}`]"
              />
            </div>
          </template >
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import {ServerTable, Event} from 'vue-tables-2'
import { required, minLength, between, email, minValue, integer } from 'vuelidate/lib/validators'
import Multiselect from 'vue-multiselect'
import vSelect from 'vue-select'
import config from '@/config/global'
import notifications from '@/config/notifications'
import jQuery from 'jquery'
import select2 from 'select2'
// import qrcode from 'qrcode'
import sha1 from 'sha1'
import io from 'socket.io-client'
import _ from 'lodash'
import moment from 'moment-timezone'
import QRious from 'qrious'
import HistoryMixedChart from '@/views/HistoryMixedChart'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import { hexToRgba } from '@coreui/coreui-pro/dist/js/coreui-utilities'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import InnoSelect from '@/views/InnoSelect';
import InnoDateTimePicker from '@/views/InnoDateTimePicker';

const encrypt    = config.encrypt;
const decrypt    = config.decrypt;
const admin_root = config.admin_root;

let $socket = null;

const clean_form = {
  name:         '',
  serialno:     '',
  brand:        '',
  end_user_id:  '',
  geo_location: '',
  remarks:      '',
  mqtt_pull:    '',
  mqtt_push:    '',
  lat: '',
  lng: '',
  demo: 'NO'
};

Vue.use(ServerTable)

Vue.component('tree-view', {
  template: `
    <ul class="custom-list">
      <li>
        <input type="checkbox" v-model="data.isExpanded" @change="toggle(data)">
        {{ data.name }}
        <ul v-if="data.isExpanded && data.subCompanies && data.subCompanies.length > 0" class="custom-list">
          <tree-view v-for="(subCompany, index) in data.subCompanies" :key="index" :data="subCompany" @toggle-event="$emit('toggle-event', $event)"></tree-view>
        </ul>
      </li>
    </ul>
  `,
  props: ['data'],
  methods: {
    toggle(data) {
      //Vue.set(node, 'isSelect', !node.isExpanded); // 使用Vue.set确保响应性
      this.$emit('toggle-event', data);
    }
  }
});

let collectCompanyIds = function(companyStructures, ids = []) {
  // 遍歷當前層的所有公司
  for (const company of companyStructures) {
    if(company.isExpanded) {
      // 將當前公司的company_id加入到ids陣列中
      ids.push(company.company_id);
      // 如果當前公司有子公司，則對子公司遞迴調用此函數
      if (company.subCompanies && company.subCompanies.length > 0) {
          collectCompanyIds(company.subCompanies, ids);
      }
    }
  }
  return ids;
}

let setAllCompanyExpanded = function(companyStructures, isExpanded) {
  // 遍歷當前層的所有公司
  for (const company of companyStructures) {
    company.isExpanded = isExpanded;
    // 如果當前公司有子公司，則對子公司遞迴調用此函數
    if (company.subCompanies && company.subCompanies.length > 0) {
      setAllCompanyExpanded(company.subCompanies, isExpanded);
    }
  }
}

function get_sub_company(app) {
  return new Promise((resolve, reject) => {
    let action = `${admin_root}/get_sub_company`;
    fetch(action, {
      method: 'POST',
      headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
      },
      body: JSON.stringify({
        keyset: 'mqtt'
      })
    }).then(res => res.json()).then(result => {
      //console.log('result: ', result);
      app.selectedCompanyIds = [];
      if(result.success) {
        //console.log('result.company_structures: ', result.company_structures);
        app.companyStructuresData = result.company_structures;
        
        collectCompanyIds(app.companyStructuresData, app.selectedCompanyIds);
        //console.log('selectedCompanyIds: ', app.selectedCompanyIds);
      } else {
        app.companyStructuresData = null;
      }
      resolve();
    }).catch(error => {
      app.selectedCompanyIds = [];
      app.companyStructuresData = null;
      resolve();
    });
  });
};

export default {
  name: 'device_manager',
  notifications,
  components: {
      ServerTable,
      Event,
      Multiselect,
      vSelect,
      HistoryMixedChart,
      VueCtkDateTimePicker,
      InnoSelect,
      InnoDateTimePicker
  },
  data(){
    let app = this;
    let chart_tooltips = {
      enabled: true,
      custom: CustomTooltips,
      intersect: true,
      mode: 'index',
      position: 'nearest',
      callbacks: {
        labelColor: function (tooltipItem, chart) {
          return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor }
        }
      }
    };

    let chart_xaxes = [{
      scaleLabel: {
        display: true,
        labelString: '時間',
        fontColor: '#fff'
      },
      gridLines: {
        display: true,
        color: '#444',          // 柔和白色格線
        borderDash: [4, 4],     // 虛線
        drawBorder: true,
        zeroLineColor: '#fff',    // 0 軸線顏色（主線）
        zeroLineWidth: 3          // 0 軸線粗細
      },
      ticks: {
        fontColor: '#fff'            // 刻度字色
      }
    }];

    return {
      showMeterHistory: false,
      fetchToken: 0,
      selected_range_options: [
      {label:'近一天', value:'1d'},
      {label:'近七天', value:'7d'},
      {label:'近一月', value:'1m'}
      ],
      selected_range: '1d',
      selected_date: moment().tz(config.timezone).format("YYYY-MM-DD"),
      selectedMeters: [],
      datePickerSelectedDate: null,
      max_selected_date: moment().tz(config.timezone).format("YYYY-MM-DD"),
      dateRangeHint:'',
      scheduleMinDate: '2023-01-01',
      start_time: null,
      end_time: null,
      max_current_kW: 0.0,
      current_kW_chart_data: {},
      history_data: {
        labels: ['2023-01', '2023-02', '2023-03'],      // X 軸標籤（時間、分類等）
        datasets: [                                     // 資料集（可以有多條線）
          {
            type: 'line',                               // 指定為曲線圖
            label: '電表負載',                           // 圖例的名稱
            data: [10, 15, 7],                          // Y 軸數值（跟 labels 一一對應)
            yAxisID: 'output-axis',
            borderColor: hexToRgba('#A7DF93', 90),      // 折線顏色
            backgroundColor: hexToRgba('#A7DF93', 90),  // 點或填充區背景色
            fill: false,                              // 是否填滿線下區域
          }
        ]
      },
      current_kW_option: {},
      default_current_kW_option: {
        responsive: true,             //圖表會自動根據父元素大小調整寬高，適應不同螢幕
        maintainAspectRatio: false,    //預設會強制圖表維持原比例，設成 false 可以更自由改高寬
        tooltips: chart_tooltips,
        legend: {                     //設定圖例
          display: true,
          labels: {
            fontColor: '#fff',        //設定圖例（如「電表負載」）的字體顏色
            //fontSize: 14,             // 字體大小
            //fontStyle: 'bold',        // 字體樣式（normal、italic、bold...）
            //boxWidth: 20              // 圖例前方小方塊寬度
          }
        },
        scales: {                     //控制 X 軸、Y 軸的標籤、格線、刻度等
          xAxes: chart_xaxes,
          yAxes: [
            {
              id: 'current_kW-axis',
              type: 'linear',
              position: 'left',
              scaleLabel: {
                display: true,      //顯示 Y 軸標題
                labelString: 'kW',  //Y 軸標題文字
                fontColor: hexToRgba('#7CFC00', 90)
              },
              gridLines: {
                display: false,
                color: '#444',  // 柔和白色格線
                borderDash: [4, 4],                 // 虛線
                drawBorder: true,
                zeroLineColor: '#fff',    // 0 軸線顏色（主線）
                zeroLineWidth: 3          // 0 軸線粗細
              },
              ticks: {
                beginAtZero: true,          //Y 軸從 0 開始
                fontColor: hexToRgba('#7CFC00', 90),            // 刻度字色
                min: 0,
                max: 1000   // ✅ 設定固定最大值，讓兩軸比例一致
              }
            },
            {
              id: 'max_limit_kW-axis',
              type: 'linear',
              position: 'right',
              scaleLabel: {
                display: true,      //顯示 Y 軸標題
                labelString: 'kW',  //Y 軸標題文字
                fontColor: hexToRgba('#FFA500', 90)
              },
              gridLines: {
                display: false,
                color: '#444',  // 柔和白色格線
                borderDash: [4, 4],                 // 虛線
                drawBorder: true,
                zeroLineColor: '#fff',    // 0 軸線顏色（主線）
                zeroLineWidth: 3          // 0 軸線粗細
              },
              ticks: {
                beginAtZero: true,    //Y 軸從 0 開始
                fontColor: hexToRgba('#FFA500', 90),            // 刻度字色
                min: 0,
                max: 1000   // ✅ 設定固定最大值，讓兩軸比例一致
              }
            }
          ]
        } 
      },
      isLoading: false,
      showCreateProfitReportFailModal: false,
      showDownloadProfitReportFailModal: false,
      target_device_id: 0,
      showIdleFee: false,
      selectMonth: null,
      month_options: [],
      device_uri: '',
      profit_report_file: null,
      showQrCode: false,
      showLogList: false,
      showTransLogList: false,
      showProfitLogList: false,
      showTotalProfitLogList: false,
      showMonthReportList: false,
      record: Object.assign({}, clean_form),
      columns: ['name', 'company_id', 'sn', 'brand', 'end_user_id', 'geo_location', 'device_activated', 'remarks', 'user_id','created'],
      logcolumns: ['transaction_id', 'start_time', 'stop_time', 'end_time', 'status', 'billing_method', 'interval', 'used_value', 'price', 'price_peak', 'used_time_idle', 'price_idle', 'sub_total', 'created'],
      transLogcolumns: ['id','inout', 'amount', 'bonus', 'deviceid', 'created'],
      profitLogcolumns: ['month', 'record_num', 'user_num', 'interval', 'used_watts', 'used_watts_peak', 'real_used_time_idle', 'cost', 'intake', 'profit_share', 'act2_profit'],
      //totalProfitLogcolumns: ['month', 'record_num', 'user_num', 'interval', 'used_watts', 'used_watts_peak', 'cost', 'intake', 'profit', 'share', 'profit_share', 'act2_profit'],
      monthProfitLogcolumns: ['company_name', 'record_num', 'user_num', 'interval', 'used_watts', 'used_watts_peak', 'real_used_time_idle', 'cost', 'intake', 'profit_share', 'act2_profit'],
      monthChargingLogcolumns: ['id', 'status','transaction_id', 'start_time', 'stop_time', 'end_time', 'billing_method', 'interval', 'used_value', 'price', 'price_peak', 'used_time_idle', 'price_idle', 'sub_total', 'created'],
      companyStructuresData: null,
      selectedCompanyIds: [],
      data: [],
      logdata:[],
      transLogdata: [],
      profitLogdata: [],
      //totalProfitLogdata: [],
      monthProfitLogdata: [],
      monthChargingLogdata: [],
      options: {
        debounce: 86400000, // 停止預設的即時搜尋
        headings: {
          name:  '名稱',
          company_id: '公司',
          sn:    '序號',
          brand: '廠牌',
          end_user_id: '擁有者',
          device_activated: '作動？',
          geo_location: '地理位置',
          remarks: '備註',
          user_id: '建立人',
          created: '最近作動時間'
        },
        orderBy: {
          column: 'created',
          ascending: false
        },
        sortable: ['name', 'company_id', 'sn', 'brand', 'end_user_id', 'geo_location', 'device_activated', 'user_id', 'created'],
        filterable: ['name', 'sn', 'brand', 'end_user_id', 'geo_location', 'device_activated'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        pagination: {
          chunk: 5,
          edge: false,
          nav: 'scroll'
        },
        perPage: 25,
        requestFunction(data) {
          if(app.companyStructuresData == null) {
            return new Promise((resolve) => {
              resolve({
                data: [],
                count: 0
              });
            });
          }

          let action = `${admin_root}/get_list/Device`;
          let params = {
              keyset: 'mqtt',
              company_ids: app.selectedCompanyIds
          };

          let ccff = this.$state.$get('ccff');
          if(ccff){
            params['ccff'] = ccff;
          }

          for(let col in data){
            params[col] = ''+data[col];
          }

          //console.info('action:', action);

          // console.info('DataTable.data:', params);
          return fetch(action, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
            },
            body: JSON.stringify(params)
          }).then(res => res.json()).then(result => {
            app.$nextTick(() => {
              app.set_mqtt_listen_list(result.data);
            });
            return {
              data: result.data || [],
              count: result.count || 0
            };
          }).catch(error => {
            app.$nextTick(() => {
              app.set_mqtt_listen_list([]);
            });
            return {
              data: [],
              count: 0
            };
          });
        }//eo requestFunction
      },
      logoptions: {
        headings: {
          transaction_id: '交易代碼',
          start_time: '起始時間',
          stop_time: '停止時間',
          end_time: '結束時間',
          status: '狀態',
          billing_method: '計費方式',
          interval: '時間',
          used_value: '使用(離峰/尖峰)',
          price: '離峰單價',
          price_peak: '尖峰單價',
          used_time_idle: '佔位時間',
          price_idle: '佔位單價',
          sub_total: '價錢',
          created: '建立時間'
        },
        orderBy: {
          column: 'created',
          ascending: false
        },
        sortable: ['user_id', 'start_time', 'stop_time', 'end_time', 'status', 'interval', 'sub_total', 'created', 'transaction_id'],
        filterable: ['user_id', 'start_time', 'stop_time', 'end_time', 'status', 'interval', 'sub_total', 'created', 'transaction_id'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        pagination: {
          chunk: 5,
          edge: false,
          nav: 'scroll'
        },
        perPage: 25,
        requestFunction(data) {
          if(app.companyStructuresData == null) {
            return new Promise((resolve) => {
              resolve({
                data: [],
                count: 0
              });
            });
          }

          let action = `${admin_root}/get_list/ChargingLog`;
          let params = {
              keyset: 'mqtt',
              queries: [
                {field: 'device_uid', value: app.target_device_id ? app.target_device_id : -1}
              ],
          };

          let ccff = this.$state.$get('ccff');
          if(ccff){
            params['ccff'] = ccff;
          }

          for(let col in data){
            params[col] = data[col];
          }

          params.skip_ccff = 1;

          return fetch(action, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
            },
            body: JSON.stringify(params)
          }).then(res => res.json()).then(result => {
            //console.info('logdata result: ', result);
            app.$nextTick(() => {
              app.LogLoaded(result.data);
            });
            return {
              data: result.data || [],
              count: result.count || 0
            };
          }).catch(error => {
            app.$nextTick(() => {
              app.LogLoaded(result.data);
            });
            return {
              data: [],
              count: 0
            };
          });
        }//eo requestFunction
      },
      transLogoptions: {
        headings: {
          id: '交易序號',
          deviceid: ' 設備序號',
          inout: '類型',
          bonus: '紅利點數',
          amount: '金額',
          created: '建立時間'
        },
        orderBy: {
          column: 'created',
          ascending: false
        },
        sortable: ['id', 'inout', 'bonus', 'amount'],
        filterable: ['id', 'inout', 'bonus', 'amount'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        pagination: {
          chunk: 5,
          edge: false,
          nav: 'scroll'
        },
        perPage: 25,
        requestFunction(data) {
          if(app.companyStructuresData == null) {
            return new Promise((resolve) => {
              resolve({
                data: [],
                count: 0
              });
            });
          }

          let action = `${admin_root}/get_list/Transaction`;
          let params = {
              keyset: 'mqtt',
              queries: [
                {field: 'device_uid', value: app.target_device_id ? app.target_device_id : -1}
              ],
          };

          let ccff = this.$state.$get('ccff');
          if(ccff){
            params['ccff'] = ccff;
          }

          for(let col in data){
            params[col] = data[col];
          }

          params.skip_ccff = 1;

          return fetch(action, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
            },
            body: JSON.stringify(params)
          }).then(res => res.json()).then(result => {
            return {
              data: result.data || [],
              count: result.count || 0
            };
          }).catch(error => {
            return {
              data: [],
              count: 0
            };
          });
        }//eo requestFunction 
      },
      profitLogoptions: {
        headings: {
          month: '月份',
          record_num: '紀錄筆數',
          user_num: '使用者數',
          interval: '上線天數',
          used_watts: '離峰度數',
          used_watts_peak: '尖峰度數',
          real_used_time_idle: '佔位時間',
          cost: '成本',
          intake: '收入',
          profit_share: '實際收入',
          act2_profit: '成本+實際收入',
        },
        orderBy: {
          column: 'created',
          ascending: false
        },
        sortable: [],
        filterable: [],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        pagination: {
          chunk: 5,
          edge: false,
          nav: 'scroll'
        },
        perPage: 25,
        requestFunction(data) {
          if(app.companyStructuresData == null) {
            return new Promise((resolve) => {
              resolve({
                data: [],
                count: 0
              });
            });
          }

          let action = `${admin_root}/transaction/profits`;
          let params = {
            keyset: 'mqtt',
            queries: [
              {field: 'device_uid', value: app.target_device_id ? app.target_device_id : -1}
            ],
          };

          let ccff = this.$state.$get('ccff');
          if(ccff){
            params['ccff'] = ccff;
          }

          for(let col in data){
            params[col] = data[col];
          }

          params.skip_ccff = 1;

          return fetch(action, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
            },
            body: JSON.stringify(params)
          }).then(res => res.json()).then(result => {
            //console.info('profitLogdata result: ', result);
            app.$nextTick(() => {
              app.ProfitLogLoaded(result.data);
            });
            return {
              data: result.data || [],
              count: result.count || 0
            };
          }).catch(error => {
            app.$nextTick(() => {
              app.ProfitLogLoaded(result.data);
            });
            return {
              data: [],
              count: 0
            };
          });
        }//eo requestFunction
      },
      monthProfitLogoptions: {
        headings: {
          company_name: '公司名稱',
          record_num: '紀錄筆數',
          user_num: '使用者數',
          interval: '上線天數',
          used_watts: '離峰度數',
          used_watts_peak: '尖峰度數',
          real_used_time_idle: '佔位時間',
          cost: '成本',
          intake: '收入',
          profit_share: '實際收入',
          act2_profit: '成本+實際收入',
        },
        orderBy: {
          column: 'created',
          ascending: false
        },
        sortable: [],
        filterable: [],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        pagination: {
          chunk: 5,
          edge: false,
          nav: 'scroll'
        },
        perPage: 500,
        perPageValues: [],
        requestFunction(data) {
          if(app.companyStructuresData == null || app.selectMonth === null) {
            return new Promise((resolve) => {
              resolve({
                data: [],
                count: 0
              });
            });
          }

          let action = `${admin_root}/reports/month_profits`;
          let params = {
            keyset: 'mqtt',
            month: app.selectMonth ? app.selectMonth : '',
            queries: [
              {field: 'company_ids', value: app.selectedCompanyIds}
            ],
          };

          let ccff = this.$state.$get('ccff');
          if(ccff){
            params['ccff'] = ccff;
          }

          for(let col in data){
            params[col] = data[col];
          }

          params.skip_ccff = 1;

          return fetch(action, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
            },
            body: JSON.stringify(params)
          }).then(res => res.json()).then(result => {
            //console.info('monthProfitLogdata result: ', result);
            app.$nextTick(() => {
              app.MonthProfitLogLoaded(result.data);
            });
            return {
              data: result.data || [],
              count: result.count || 0
            };
          }).catch(error => {
            app.$nextTick(() => {
              app.MonthProfitLogLoaded(result.data);
            });
            return {
              data: [],
              count: 0
            };
          });
        }//eo requestFunction
      },
      monthChargingLogoptions: {
        headings: {
          id: '充電樁名稱',
          status: '場域',
          transaction_id: '交易代碼',
          start_time: '起始時間',
          stop_time: '停止時間',
          end_time: '結束時間',
          billing_method: '計費方式',
          interval: '時間',
          used_value: '使用(離峰/尖峰)',
          price: '離峰單價',
          price_peak: '尖峰單價',
          used_time_idle: '佔位時間',
          price_idle: '佔位單價',
          sub_total: '價錢',
          created: '建立時間'
        },
        orderBy: {
          column: 'created',
          ascending: false
        },
        sortable: [],
        filterable: [],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        pagination: {
          chunk: 5,
          edge: false,
          nav: 'scroll'
        },
        perPage: 10,
        perPageValues: [],
        requestFunction(data) {
          if(app.companyStructuresData == null || app.selectMonth === null) {
            return new Promise((resolve) => {
              resolve({
                data: [],
                count: 0
              });
            });
          }

          let action = `${admin_root}/reports/month_charging_logs`;
          let params = {
            keyset: 'mqtt',
            month: app.selectMonth ? app.selectMonth : '',
            queries: [
              {field: 'company_ids', value: app.selectedCompanyIds},
            ],
          };

          let ccff = this.$state.$get('ccff');
          if(ccff){
            params['ccff'] = ccff;
          }

          for(let col in data){
            params[col] = data[col];
          }

          params.skip_ccff = 1;

          return fetch(action, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
            },
            body: JSON.stringify(params)
          }).then(res => res.json()).then(result => {
            //console.info('monthChargingLogoptions result: ', result);
            app.$nextTick(() => {
              app.MonthChargingLogLoaded(result.data);
            });
            return {
              data: result.data || [],
              count: result.count || 0
            };
          }).catch(error => {
            app.$nextTick(() => {
              app.MonthChargingLogLoaded(result.data);
            });
            return {
              data: [],
              count: 0
            };
          });
        }//eo requestFunction
      },
      useVuex: false,
      theme: 'bootstrap4',
      template: 'default'
    };//eo return
  },//eo data

  created() {
    let app = this;
  },

  mounted(){
    let app = this;
    let twoYearAgo = moment().tz(config.timezone).subtract(2, 'years');
    let today = moment().tz(config.timezone);
    this.scheduleMinDate = twoYearAgo.format("YYYY-MM-DD").toString();
    this.selected_date = today.format("YYYY-MM-DD");
    this.max_selected_date = today.format("YYYY-MM-DD");
    this.onDatePicked(this.selected_date);
    

    // Search field 按下Enter後開始搜尋
    this.$nextTick(() => {
      let searchInput = document.querySelector('.VueTables__search-field input');
      if (searchInput) {
        // 取消 Vue Tables 內部的即時搜尋
        /*searchInput.addEventListener('input', (event) => {
          console.info('searchInput event:', event);
        }, true); // 捕獲模式，確保先執行*/
        
        // 監聽 Enter 鍵，才真正搜尋
        searchInput.addEventListener('keyup', (event) => {
          //console.info('keyup: ', event.key);
          //this.showSuccess({message:`key: ${event.key}`});
          if (event.key === "Enter" || event.key === "Go" || event.key === "Search") {
            this.$refs.dataTable.setFilter(searchInput.value);
            
            //強制清除 Vue Tables 內部的 debounce 計時器
            //this.$refs.dataTable.query = searchInput.value; // 直接覆寫內部值，避免 24 小時後觸發
          }
        });

        // 監聽 "失去焦點" (按 "下一步" 後，強制搜尋)
        searchInput.addEventListener('blur', () => {
            //console.info('blur event: 搜尋觸發');
            //this.showSuccess({message:'blur event: 搜尋觸發'});
            this.$refs.dataTable.setFilter(searchInput.value);
        });
      }
    });

    this.generateMonths();

    if(app.companyStructuresData == null){
      get_sub_company(app).then(()=>{
        //console.log('done');
        app.$refs['dataTable'].refresh();
        app.get_meters();
      });
    } else {
      app.get_meters();
    }

    $socket = io(config.socket_entry, {
      origins: '*:*',
      secure: true,
      forceNew: true,
      transports: ['polling'],
      cookie: false,
    });
    $socket.on('connect', () => {
      console.info('socket connected...');
    });

    $socket.on('mqtt_connected', (data) => {
      if(data.message.indexOf('&') !== -1){
        let parsed = config.mqtt_msg_parser(data.message);

        // console.info('mqtt parsed:', parsed);

        if(parsed && parsed.deviceid){
          jQuery('#PHolder'+parsed.deviceid).html('<span class="text-success"><i class=" fa fa-check"></i></span>')
        } else {
          jQuery('#PHolder'+parsed.deviceid).html('<span class="text-danger"><i class=" fa fa-times"></i></span>')
        }
      }
    });

    this.handler = function(records) {
      // console.info('vue-tables.loaded:', records);
      if(records !== null && records.count){
        //collect device ids
        let device_ids = [];
        records.data.forEach((record, idx) => {
          if(record.id){
            device_ids.push(record.id);

            //clear connect status
            jQuery('#PHolder' + record.sn).html('<span><i class="fa fa-question-circle"></i></span>')
          }
        });

        if(device_ids.length){
          let skip = {};
          let action = `${config.mqtt_root}/get_latest_charging_record`;
          fetch(action, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
            },
            body: JSON.stringify({
              user_id:   encodeURIComponent(app.$state.$get('adminuser').uuid),
              device_ids: device_ids,
              keyset: 'mqtt',
            })
          }).then(res => res.json()).then(charging_records => {
            //console.info('charging_records:', charging_records);
            if(charging_records.success){
              charging_records.records.forEach((record) => {
                let status = '';

                skip[record.device_uid] = 1;

                if(record.end_time && record.end_time>=record.start_time){
                  // console.info(record.end_time);
                  status = '<span class="text-warning">結束充電</span>（結束於'+moment.unix(record.end_time).tz(config.timezone).format('YYYY-MM-DD HH:mm')+'）';
                } else if(record.stop_time) {
                  status = '<span class="text-success">正在佔位</span>（起始於'+moment.unix(record.start_time).tz(config.timezone).format('YYYY-MM-DD HH:mm')+'）';
                } else if(record.start_time) {
                  status = '<span class="text-info">正在充電</span>（起始於'+moment.unix(record.start_time).tz(config.timezone).format('YYYY-MM-DD HH:mm')+'）';
                } else {
                  status = '尚未使用';
                }

                jQuery('#PCHolder' + record.device_uid).html(status);
              });
            }

            device_ids.forEach((device_id) => {
              if(skip[device_id]){
                return true;
              }
              jQuery('#PCHolder' + device_id).html('<span class="text-danger">暫無資料</span>');
            });
          }).catch(error => {
          });
        }
      }
    };
    Event.$on('vue-tables.loaded', this.handler);
  },
  
  beforeDestroy() {
    if ($socket) {
      $socket.disconnect();
      $socket = null;
    }
    Event.$off('vue-tables.loaded', this.handler);
  },

  methods: {
    handleToggle() {
      let app = this;
      //console.log('companyStructuresData: ', this.companyStructuresData);
      app.selectedCompanyIds = [];
      collectCompanyIds(app.companyStructuresData, app.selectedCompanyIds);
      //console.log('selectedCompanyIds: ', app.selectedCompanyIds);
      app.$refs['dataTable'].refresh();
      app.get_meters();
    },

    toggleAllCheckboxes(company, isExpanded) {
      let app = this;
      // 如果當前公司有子公司，則對子公司遞迴調用此函數
      if (company && company.subCompanies && company.subCompanies.length > 0) {
        setAllCompanyExpanded(company.subCompanies, isExpanded);
      }
      this.handleToggle();
    },

    get_used_value(row) {
			let used_value = '0.000/0.000度';
			if(row) {
				if(row.billing_method == 'TIME') {
					if((parseFloat(row.used_watts) + parseFloat(row.used_watts_peak)) > 0.2){
						used_value = Math.ceil(row.used_time/60) + '/' + Math.ceil(row.used_time_peak/60) + '分鐘';
					} else {
						used_value = '0/0分鐘';
					}
				} else {
					used_value = row.used_watts + '/' + row.used_watts_peak + '度';
				}
			}
			return used_value;
		},//eo get_used_value

    get_real_used_time_idle(row) {
			let [idle_free_period, idle_interval_rate, idle_max_price] = row.idle_info.split('/');
			let idle_free_period_sec = idle_free_period * 60;
			let idle_time = row.used_time_idle - idle_free_period_sec;
			if(idle_time <= 0) {
				idle_time = 0;
			}
			//console.info(Math.floor(idle_time / 60 ) + '分鐘');
			return Math.floor(idle_time / 60 ) + '分鐘';
		},

    genRow(row_id) {
      // console.info('row clicked: ', row_id);
      this.showQrCode = true;
      row_id          = encodeURIComponent(config.encrypt(row_id, config.ffkey, config.ffiv));

      let msg = `${config.frontend}?uuid=${row_id}`;
          
      (new QRious({
          element: document.getElementById('qrcode-canvas'),
          value: msg,
          size: 160
      }));
      
      this.device_uri = `${config.frontend}?uuid=${row_id}`;
    },//eo onRowClick

    openLog(row){
      let app = this;
      app.target_device_id = row.id;
      this.logcolumns = ['transaction_id', 'start_time', 'end_time', 'status', 'billing_method', 'interval', 'used_value', 'price', 'price_peak', 'sub_total', 'created'];
      app.$refs['logDataTable'].refresh();
      app.showLogList = true;
    },

    LogLoaded(datas){
      //console.info('datas:', datas);
      let have_idle_fee = datas.find(data => data.used_time_idle > 0);
      if(have_idle_fee) {
        this.logcolumns = ['transaction_id', 'start_time', 'stop_time', 'end_time', 'status', 'billing_method', 'interval', 'used_value', 'price', 'price_peak', 'used_time_idle', 'price_idle', 'sub_total', 'created'];
      }
    },

    openTransLog(device_id){
      let app = this;
      app.target_device_id = device_id;
      app.$refs['transLogDataTable'].refresh();
      app.showTransLogList = true;
    },

    openProfitLog(row) {
      let app = this;
      app.target_device_id = row.id;
      this.profitLogcolumns = ['month', 'record_num', 'user_num', 'interval', 'used_watts', 'used_watts_peak', 'cost', 'intake', 'profit_share', 'act2_profit'];
      app.$refs['profitLogDataTable'].refresh();
      app.showProfitLogList = true;
    },

    ProfitLogLoaded(datas){
      //console.info('datas:', datas);
      let have_idle_fee = datas.find(data => data.real_used_time_idle > 0);
      if(have_idle_fee) {
        this.profitLogcolumns = ['month', 'record_num', 'user_num', 'interval', 'used_watts', 'used_watts_peak', 'real_used_time_idle', 'cost', 'intake', 'profit_share', 'act2_profit'];
      }
    },

    openMonthReport() {
      let app = this;
      //console.info('company_id:', app.$state.$get('adminuser').ccid);
      app.selectMonth = null;
      app.profit_report_file = null;
      app.showMonthReportList = true;
    },

    async handleSelection(newValue){
      let app = this;
      app.isLoading = true;  // 開啟 loading

      this.monthProfitLogcolumns = ['company_name', 'record_num', 'user_num', 'interval', 'used_watts', 'used_watts_peak', 'cost', 'intake', 'profit_share', 'act2_profit'];
      this.monthChargingLogcolumns =['id', 'status','transaction_id', 'start_time', 'end_time', 'billing_method', 'interval', 'used_value', 'price', 'price_peak', 'sub_total', 'created'];

      try {
        //console.info('newValue:', newValue);
        if(newValue) {
          await app.createProfitReport();
        } else {
          app.profit_report_file = null;
          app.selectMonth = null;
          app.$refs['monthProfitLogDataTable'].refresh();
          app.$refs['monthChargingLogDataTable'].refresh();
          //app.$set(app, 'monthProfitLogData', []);
          //app.$set(app, 'monthChargingLogData', []);
          //app.monthProfitLogData = []; //async/await的原因必須在這邊作清空動作
          //app.monthChargingLogData = []; //async/await的原因必須在這邊作清空動作
        }
      } catch (err) {
        console.info('handleSelection error:', err);
        app.profit_report_file = null;
        app.selectMonth = null;
        app.$refs['monthProfitLogDataTable'].refresh();
        app.$refs['monthChargingLogDataTable'].refresh();
      } finally {
        app.isLoading = false;
      }
    },

    MonthProfitLogLoaded(datas){
      //console.info('datas:', datas);
      let have_idle_fee = datas.find(data => data.real_used_time_idle > 0);
      if(have_idle_fee) {
        this.monthProfitLogcolumns = ['company_name', 'record_num', 'user_num', 'interval', 'used_watts', 'used_watts_peak', 'real_used_time_idle', 'cost', 'intake', 'profit_share', 'act2_profit'];
      }
    },

    MonthChargingLogLoaded(datas){
      //console.info('datas:', datas);
      let have_idle_fee = datas.find(data => data.used_time_idle > 0);
      if(have_idle_fee) {
        this.monthChargingLogcolumns = ['id', 'status','transaction_id', 'start_time', 'stop_time', 'end_time', 'billing_method', 'interval', 'used_value', 'price', 'price_peak', 'used_time_idle', 'price_idle', 'sub_total', 'created'];
      }
    },

    generateMonths() {
      let app = this;
      app.month_options = [];
      let currentDate = new Date();
      let year = "";
      let month = "";
      currentDate.setDate(1);//set to the first day of each month.
      for(let i = 0; i <=24; i++) {
        year = currentDate.getFullYear();
        month = currentDate.getMonth() + 1;
        app.month_options.push(`${year}-${month.toString().padStart(2, '0')}`);
        currentDate.setMonth(currentDate.getMonth() - 1);
      }
      //app.month_options.reverse();
    },

    createProfitReport() {
      let app = this;
      if(app.selectMonth === null) {
        app.profit_report_file = null;
        return Promise.resolve();  //馬上 resolve
      } else {
        let action = `${admin_root}/reports/create_profit_report`;
        let params = {
          keyset: 'mqtt',
          month: app.selectMonth ? app.selectMonth : '',
          queries: [
            {field: 'company_ids', value: app.selectedCompanyIds},
          ],
        };

        let ccff = this.$state.$get('ccff');
        if(ccff){
          params['ccff'] = ccff;
        }

        params.skip_ccff = 1;

        return fetch(action, {
          method: 'POST',
          headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
          },
          body: JSON.stringify(params)
        }).then(res => res.json()).then(result => {
          if(result && result.success && result.profit_report_file) {
            app.profit_report_file = result.profit_report_file;
          } else {
            app.profit_report_file = null;
            app.selectMonth = null;
            app.showCreateProfitReportFailModal = true;
          }
        }).catch(error => {
          app.profit_report_file = null;
          app.selectMonth = null;
          app.showCreateProfitReportFailModal = true;
          //console.info('monthChargingLogoptions error', error);
        });
      } 
    },

    /*download_profit_report_file() {
      let app = this;
      if(app.profit_report_file != null) {
        const link = document.createElement('a');
        link.href = app.profit_report_file;
        link.click();
      }
    },*/

    download_profit_report_file() {
      let app = this;
      app.showDownloadProfitReportFailModal = false;
      let action = `${admin_root}/reports_download/${app.profit_report_file}`;
      fetch(action, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + app.$state.$get('adminuser').token   // 如果需要token
        },
      }).then(response => {
        if (!response.ok) {
          throw new Error('Download failed');
        }
        return response.blob();
      }).then(async blob => {
        const text = await blob.text();
        let isError = false;
        let json = null;

        try {
          json = JSON.parse(text);
          if (json.success === false) {
            isError = true;
          }
        } catch(e) {
          // 不是 JSON → 正常檔案
        }

        if (isError) {
          // 顯示錯誤 modal
          app.showDownloadProfitReportFailModal = true;
          //console.error('下載錯誤:', json.message);
        } else {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = app.profit_report_file; // 可自訂檔名
          document.body.appendChild(link);
          link.click();

          link.remove();
          window.URL.revokeObjectURL(url);
        }
      }).catch(err => {
        app.showDownloadProfitReportFailModal = true;
        //console.error(err);
      });
    },

    getRangeHint() {
      //console.log(`dateRangeHint ${this.selected_date} ${this.selected_range}`);
      if (!this.selected_date || !this.selected_range) 
        return "";

      let now = moment().tz(config.timezone);
      let target_date = moment.tz(this.selected_date, "YYYY-MM-DD HH:mm:ss", config.timezone);
      let st = null;
      let et = null;
      let start = '';
      let end = '';
      if(this.selected_range == '7d') {
        et = moment.tz(this.selected_date, "YYYY-MM-DD HH:mm:ss", config.timezone).endOf('day');;
        st = moment.tz(this.selected_date, "YYYY-MM-DD HH:mm:ss", config.timezone).subtract(6, 'days');
      } else if(this.selected_range == '1m') {
        if(target_date.format("YYYY-MM") === now.format("YYYY-MM")) { //this month
          et = now;
          st = now.clone().startOf('month');
        } else {
          et = moment.tz(this.selected_date, "YYYY-MM-DD HH:mm:ss", config.timezone).endOf('month');
          st = moment.tz(this.selected_date, "YYYY-MM-DD HH:mm:ss", config.timezone).startOf('month');
        }
      } else { //1 day
        if(target_date.format("YYYY-MM-DD") === now.format("YYYY-MM-DD")) { //today
          et = now;
          st = now.clone().subtract(1, 'days');
        } else {
          et = moment.tz(this.selected_date, "YYYY-MM-DD HH:mm:ss", config.timezone).add(1, 'days');
          st = moment.tz(this.selected_date, "YYYY-MM-DD HH:mm:ss", config.timezone);
        }
      }
      start = st.format("YYYY-MM-DD");
      end = et.format("YYYY-MM-DD");

      return `${start} ~ ${end}`;
    },

    openMeterHistory(){
      let app = this;
      let twoYearAgo = moment().tz(config.timezone).subtract(2, 'years');
      let today = moment().tz(config.timezone);
      this.scheduleMinDate = twoYearAgo.format("YYYY-MM-DD").toString();
      this.selected_date = today.format("YYYY-MM-DD");
      this.max_selected_date = today.format("YYYY-MM-DD");
      
      app.get_meters();
      app.showMeterHistory = true;
    },

    onDatePicked(value) {
      //console.log("選到日期:", value);
      //console.log("datePickerSelectedDate:", this.datePickerSelectedDate);
      this.dateRangeHint = this.getRangeHint();
      this.fetchAllMeterHistory();
    },

    async fetchAllMeterHistory() {
      if(this.showMeterHistory) {
        const token = ++this.fetchToken;
        for(const selectedMeter of this.selectedMeters) {
          for(const meterid of selectedMeter.meterids) {
            if(this.showMeterHistory == false) return;
            if(token !== this.fetchToken) return;
            
            // 複製 option
            this.current_kW_option[`${selectedMeter.project_name}-${meterid}`] = JSON.parse(JSON.stringify(this.default_current_kW_option));
            
            // 呼叫歷史資料
            await this.get_meter_history_by_options(this.selected_date, this.selected_range, selectedMeter.project_name, meterid);

            if(this.showMeterHistory == false) return;
            if(token !== this.fetchToken) return;
            // 延遲，例如 500ms
            await new Promise(resolve => setTimeout(resolve, 100));
          }
        }
      }
    },

    getGlobalIndex(groupIndex, indexInGroup) {
      let count = 0;
      for (let i = 0; i < groupIndex; i++) {
        count += this.selectedMeters[i].meterids.length;
      }
      return count + indexInGroup;
    },

    get_meters() {
      let app = this;
      let action = `${admin_root}/get_meters`;
      let params = {
        company_ids: app.selectedCompanyIds
      };
      return fetch(action, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
        },
        body: JSON.stringify(params)
      }).then(res => res.json()).then(result => {
        //console.info(`result: ${JSON.stringify(result)}`);
        app.selectedMeters = [];
        for (const item of result.results) {
          let selectedMeter = {
            name: item.name,
            project_name: item.project_name,
            meterids: item.meterids.split(',').map(s => s.trim())
          }
          app.selectedMeters.push(selectedMeter);
        }
        app.fetchAllMeterHistory();
      }).catch(error => {
        app.selectedMeters = [];
      });
    },

    get_meter_history(date, project_name, meterid) {
      return new Promise((resolve, reject) => {
        let app = this;
        let now = moment().tz(config.timezone);
        if(app.datePickerSelectedDate === now.format("YYYY-MM-DD")) { //today
          app.end_time = now;
          app.start_time = now.clone().subtract(1, 'days');
        } else {
          app.end_time = moment.tz(date, "YYYY-MM-DD HH:mm:ss", config.timezone).add(1, 'days');
          app.start_time = moment.tz(date, "YYYY-MM-DD HH:mm:ss", config.timezone);
        }
        
        //console.info(`project_name: ${project_name}, meterid: ${meterid}`);
        //console.info('app.start_time:', app.start_time.format('YYYY-MM-DD HH:mm:ss'));
        //console.info('app.end_time:', app.end_time.format('YYYY-MM-DD HH:mm:ss'));
        //let project_name = 'JHTNG';
        //app.project_name = '';
        //app.meterid = 1;

        // 你原本的 this.$jsonp
        let action = `${config.api_root}/get_meter_history`;
        let params = {
            keyset: 'mqtt',
        };

        fetch(action, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
          },
          body: JSON.stringify({
            project_name: project_name,
            meterid: meterid,
            start_time: app.start_time.format('YYYY-MM-DD HH:mm:ss'),
            end_time: app.end_time.format('YYYY-MM-DD HH:mm:ss'),
          })
        }).then(res => res.json()).then(meter_historys => {
          //console.info('meter_historys:', meter_historys);
        
          let duration = moment.duration(app.end_time.diff(app.start_time));

          duration = Math.ceil(duration.asDays());

          let group_str = 'YYYY/MM/DD';

          if(duration <= 1){
            group_str = 'MM/DD HH:mm';
          } else if (duration >= 7 && duration <= 92) {
            group_str = 'MM/DD';
          } else if (duration >= 92 && duration <= 366) {
            group_str = 'MM';
          } else if (duration >= 366 ) {
            group_str = 'YYYY';
          }

          //format data
          let labels       = [];
          let current_kW_set = [];
          let max_limit_kW_set = [];

          //console.info('meter_historys.success:', meter_historys.success);
          if(meter_historys.success !== false) {
            meter_historys.forEach((history) => {
              //let timestamp_str = moment(history.timestamp_str, 'YYYY/MM/DD HH:mm:ss');
              //labels.push(timestamp_str.format(group_str));

              let G_TIME = moment(history.G_TIME, 'YYYY/MM/DD HH:mm:ss');
              labels.push(G_TIME.format(group_str));

              current_kW_set.push(parseFloat(history.current_kW).toFixed(1));
              max_limit_kW_set.push(parseFloat(history.max_limit_kW).toFixed(1));
            });
          }
          
          // 更新 Y 軸最大值(左軸和右軸)
          const max_limit_kW = max_limit_kW_set.length > 0 ? Math.max(...max_limit_kW_set) : 1000;
          const set_max_limit_kW = Math.ceil(max_limit_kW / 10) * 10;
          //console.info(`[${meterid}] max_limit_kW: ${max_limit_kW}(${set_max_limit_kW})`);

          // 先更新資料
          app.current_kW_chart_data = {
            ...app.current_kW_chart_data,
            [`${project_name}-${meterid}`]: {
              labels: labels.slice(),
              datasets: [
                {
                  type: 'line',
                  label: `電表[${meterid}]負載`,
                  yAxisID: 'current_kW-axis',
                  data: current_kW_set.slice(),
                  borderColor: hexToRgba('#7CFC00', 90),
                  backgroundColor: hexToRgba('#7CFC00', 90),
                  fill: false,
                },
                {
                  type: 'line',
                  label: `電表[${meterid}]最大負載`,
                  yAxisID: 'max_limit_kW-axis',
                  data: max_limit_kW_set.slice(),
                  borderColor: hexToRgba('#FFA500', 90),
                  backgroundColor: hexToRgba('#FFA500', 90),
                  fill: false,
                }
              ]
            }
          };

          // 等 Vue 更新 DOM 後再更新 Y 軸
          this.$nextTick(() => {
            const chartRef = this.$refs[`chart-${project_name}-${meterid}`];
            const chartInstance = Array.isArray(chartRef) ? chartRef[0] : chartRef;
            if(chartInstance && chartInstance.updateYAxisMax){
              chartInstance.updateYAxisMax(set_max_limit_kW);
            }
          });

          resolve(); // 完成後 resolve
        }).catch(error => {
          reject(error)
        });
      });
    },

    get_meter_history_by_options(date, range, project_name, meterid) {
      return new Promise((resolve, reject) => {
        let app = this;
        //console.info(`project_name: ${project_name}, meterid: ${meterid}`);
        //console.info('selected_date:', date);
        //console.info('selected_range:', range);

        let action = `${config.api_root}/get_meter_history_by_options`;
        let params = {
            keyset: 'mqtt',
        };

        fetch(action, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
          },
          body: JSON.stringify({
            project_name: project_name,
            meterid: meterid,
            selected_date: date,
            selected_range: range,
          })
        }).then(res => res.json()).then(meter_historys => {
          //console.info('meter_historys:', meter_historys);

          let group_str = 'YYYY/MM/DD';
          if(range == '7d') {
            group_str = 'MM/DD';
          } else if(range == '1m') {
            group_str = 'MM/DD';
          } else if(range == '6m') {
            group_str = 'MM';
          } else { //1 day
            group_str = 'MM/DD HH:mm';
          }

          //format data
          let labels       = [];
          let current_kW_set = [];
          let max_limit_kW_set = [];
          let current_kW_unit = `負載`;
          if(range != '1d') { //7d、1m、6m 顯示當天最高負載數值
            current_kW_unit = `最高負載`;
          }

          //console.info('meter_historys.success:', meter_historys.success);
          if(meter_historys.success !== false) {
            meter_historys.forEach((history) => {
              //let timestamp_str = moment(history.timestamp_str, 'YYYY/MM/DD HH:mm:ss');
              //labels.push(timestamp_str.format(group_str));

              let G_TIME = moment(history.G_TIME, 'YYYY/MM/DD HH:mm:ss');
              labels.push(G_TIME.format(group_str));

              current_kW_set.push(parseFloat(history.current_kW).toFixed(1));
              max_limit_kW_set.push(parseFloat(history.max_limit_kW).toFixed(1));
            });
          }

          app.max_current_kW = current_kW_set.length > 0 ? Math.max(...current_kW_set) : 0.0;
          
          // 更新 Y 軸最大值(左軸和右軸)
          const max_limit_kW = max_limit_kW_set.length > 0 ? Math.max(...max_limit_kW_set) : 1000;
          const set_max_limit_kW = Math.ceil(max_limit_kW / 10) * 10;
          //console.info(`[${meterid}] max_limit_kW: ${max_limit_kW}(${set_max_limit_kW})`);

          // 先更新資料
          app.current_kW_chart_data = {
            ...app.current_kW_chart_data,
            [`${project_name}-${meterid}`]: {
              labels: labels.slice(),
              datasets: [
                {
                  type: 'line',
                  label: `${current_kW_unit}`,
                  yAxisID: 'current_kW-axis',
                  data: current_kW_set.slice(),
                  borderColor: hexToRgba('#7CFC00', 90),
                  backgroundColor: hexToRgba('#7CFC00', 90),
                  fill: false,
                },
                {
                  type: 'line',
                  label: `負載上限`,
                  yAxisID: 'max_limit_kW-axis',
                  data: max_limit_kW_set.slice(),
                  borderColor: hexToRgba('#FFA500', 90),
                  backgroundColor: hexToRgba('#FFA500', 90),
                  fill: false,
                }
              ]
            }
          };

          // 等 Vue 更新 DOM 後再更新 Y 軸
          this.$nextTick(() => {
            const chartRef = this.$refs[`chart-${project_name}-${meterid}`];
            const chartInstance = Array.isArray(chartRef) ? chartRef[0] : chartRef;
            if(chartInstance && chartInstance.updateYAxisMax){
              chartInstance.updateYAxisMax(set_max_limit_kW);
            }
          });

          resolve(); // 完成後 resolve
        }).catch(error => {
          reject(error)
        });
      });
    },

    async handleSelectedRange(newValue){
      this.dateRangeHint = this.getRangeHint();
      this.fetchAllMeterHistory();
    },

    set_mqtt_listen_list(datas){
      let device_ids = [];
      datas.forEach((data, idx) => {
        device_ids.push(data.sn);
      });
      //console.info('device_ids:', device_ids);
      $socket.emit('mqtt_socket', {
        type: 'mqtt-listen-list',
        token: this.$state.$get('adminuser').token,
        device_ids: device_ids
      });
    },
  },//eo methods
  
  validations: {
    record: {
      name: {
        required,
        minLength: minLength(2)
      },
      serialno: {
        required,
        minLength: minLength(4),
      },
      end_user_id: {
        required: false,
          integer,
        // minValue: minValue(1)
      },
      company_id: {
        required: false,
        integer
        // minLength: minLength(1)
      },
    }
  },//eo validations
  
};
</script>
<style lang="scss">
.card-body{padding:0;}
.add-btn{}
.help-text{margin-top: 0.5rem; margin-left: 0.8rem;}
.multiselect__input{width:100%;border:none;}
#qrcode-canvas{
  display:inline-block;
  margin: auto;
}
#dataTable {
  width: 95%;
  margin: 0 auto;
  margin-top: 0.5rem;
  font-size: 0.75rem;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .vue-title {
    text-align: center ;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.25rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }

  .VueTables__sortable {
    padding: 0.25rem;
  }
}
.modal .modal-xl {
	max-width: 90% !important;
    width: 90% !important;
}

.modal-footer-center {
  justify-content: center !important;
}

ul.custom-list {
  padding-left: 1rem; /* 调整整个列表的左侧缩进 */
}

.chart-panel {
  flex: 1;            /* 右側佔據剩餘空間 */
  display: flex;
  flex-direction: column; /* 垂直排列 */
  align-items: center;    /* 水平置中 */
  overflow-y: auto;       /* 超出高度出現垂直滾動條 */
  padding-left: 10px;
}

.chart-panel > div {
  width: 100% !important;     /* 設定讓圖表自適應寬度 */
  height: 400px;              /* 圖表高度 */
  margin-bottom: 12px;
}

.bg-even {
  background-color: #1e1e1e;  /* 深灰 */
  padding: 10px;
  border-radius: 8px;
}
.bg-odd {
  background-color: #2a2a2a;  /* 稍微亮一點 */
  padding: 10px;
  border-radius: 8px;
}
.center-btn-sm{
	display: flex;
	align-items: center;
	justify-content: center;
	height: 2rem;
	max-width: 100%;
	min-width: 100%;
	font-size: 1rem;
	margin: 0.5px 0px;
}
.scrollable-div {
  max-height: 200px; /* 設置 div 的高度 */
  overflow-y: auto; /* 當內容超出 div 的高度時，顯示垂直滾動條 */
  /* 為了美觀，可以設置一些額外的樣式 */
  border: 1px solid #ccc;
  padding: 10px;
}
/* 基準日期、查詢等標題文字 */
.label-text {
  color: #000000; /* 深藍灰色，對比度高且專業 */
  font-size: 1.05rem;
}

/* 計算出來的日期區間文字 */
.result-text {
  color: #0056b3;
  font-weight: 700;
  letter-spacing: 0.5px;
}

/* 為資料區間增加一個淺色背襯，加強視線引導 */
.range-info-box {
  background-color: #f8f9fa; /* 極淺灰背景 */
  padding: 10px 20px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}
</style>
